import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import { fetchDownloadCmr } from "../../../../../redux/api/raports.api";
import { useAppDispatch } from "../../../../../redux/hooks";
import { ActiveTransportsDataInterface } from "../../../../../redux/interfaces/transport.interface";

function TransportHistoryActionButton({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: ActiveTransportsDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();

  const { id_ruta_intranod } = crudData;

  const handleDownloadCmr = () => {
    if (id_ruta_intranod && itemId) {
      dispatch(
        fetchDownloadCmr({
          idTransport: itemId,
        }),
      );
    }
  };

  return (
    <ActionMenu
      items={[
        {
          id: "download-cmr",
          label: "Descarca CMR",
          icon: "DOCUMENTS",
          kind: "download",
          tooltip:
            id_ruta_intranod && itemId
              ? "Descarca documentul CMR al transportului."
              : "CMR este disponibil dupa asocierea transportului cu o ruta intranod.",
          disabled: !id_ruta_intranod || !itemId,
          onClick: handleDownloadCmr,
        },
      ]}
      minItemsForMenu={2}
      title={String(itemId)}
      ariaLabel={`Actiuni pentru transportul ${itemId}`}
    />
  );
}

export default TransportHistoryActionButton;
